import React from "react";
import PropTypes from "prop-types";

const ArrowLine = ({
  curve,
  xStartPos,
  yStartPos,
  xEndPos,
  yEndPos,
  arrowHeadWidth,
  arrowHeadHeight,
  fill,
  strokeWidth,
  strokeDasharray,
  arrowHeadRotate,
}) => {
  let arrowPath = `l ${xEndPos} ${yEndPos}`;
  if (curve) {
    arrowPath = `c 0 ${yEndPos} 0 ${yEndPos} ${xEndPos} ${yEndPos}`;
  }

  return (
    <React.Fragment>
      <path
        d={`m ${xStartPos} ${yStartPos} ${arrowPath}`}
        fill="none"
        stroke={fill}
        strokeWidth={strokeWidth}
        strokeDasharray={strokeDasharray}
      />
      <polygon
        points={`${xStartPos - arrowHeadWidth / 2},${
          yStartPos - arrowHeadHeight
        } 
        ${xStartPos + arrowHeadWidth / 2},${yStartPos - arrowHeadHeight}
        ${xStartPos},${yStartPos}`}
        fill={fill}
        transform={`rotate(${arrowHeadRotate}, ${xStartPos}, ${yStartPos})`}
      />
    </React.Fragment>
  );
};

ArrowLine.defaultProps = {
  curve: false,
  fill: "#b7b7b7",
  strokeWidth: 1.5,
  strokeDasharray: "4 1",
  arrowHeadWidth: 10,
  arrowHeadHeight: 6,
  arrowHeadRotate: 0, // points down
};

ArrowLine.propTypes = {
  xStartPos: PropTypes.number.isRequired,
  yStartPos: PropTypes.number.isRequired,
  xEndPos: PropTypes.number.isRequired,
  yEndPos: PropTypes.number.isRequired,
  curve: PropTypes.bool,
  arrowHeadWidth: PropTypes.number,
  arrowHeadHeight: PropTypes.number,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
  strokeDasharray: PropTypes.string,
  arrowHeadRotate: PropTypes.number,
};

export default ArrowLine;
